import { ref, onMounted, onUnmounted } from 'vue';

export function useAccordion() {
  const isExpanded = ref(false);
  const contentHeight = ref(0);
  const contentRef = ref(null);

  const toggle = () => {
    isExpanded.value = !isExpanded.value;
  };

  const calculateHeight = () => {
    if (contentRef.value) {
      contentHeight.value = contentRef.value.scrollHeight;
    }
  };

  onMounted(() => {
    window.addEventListener('resize', calculateHeight);
    calculateHeight();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', calculateHeight);
  });

  return {
    isExpanded,
    toggle,
    contentRef,
    contentHeight
  };
}